import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promote',
  templateUrl: './promote.component.html',
  styles: []
})
export class PromoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
